import { login, register } from '../../api/server/auth'
import { saveItem, removeItem, getItemObject } from '../../utils/storage'


const state = {
  userinfo: {},
  identityAccess: {}
}

const getters = {
  userinfo: state => {
    return state.userinfo
  },
}

const actions = {
  LOAD_USERINFO ({ commit }) {
    let userinfo = loadUserInfo()
    commit('SET_USERINFO', userinfo)
  },
  USER_LOGIN ({ commit, dispatch }, data) {
    return new Promise((resolve, reject) => {
      login(data).then(rdata => {
        if (rdata.code === 200 && rdata.data && rdata.data.user) {
          let userinfo = rdata.data.user
          userinfo.isLogin = true
          userinfo.token = rdata.data.token
          commit('SET_USERINFO', userinfo)
          saveUserInfo(userinfo)
          resolve(userinfo)
        } else {
          reject(new Error(rdata.message))
        }
      }).catch(err => {
        reject(err)
      })
    })
  },
  CLEAN_USERINFO ({ commit }) {
    console.log('clean userinfo')
    commit('SET_USERINFO', {})
    removeUserInfo()
  },
  REGISTER ({ commit, dispatch }, data) {
    return new Promise((resolve, reject) => {
      register(data).then(rdata => {
        if (rdata.code === 200 && rdata.data && rdata.data.user) {
          let userinfo = rdata.data.user
          userinfo.isLogin = true
          userinfo.token = rdata.data.token
          commit('SET_USERINFO', userinfo)
          saveUserInfo(userinfo)
          // resolve(userinfo)
          resolve(rdata)
        } else {
          reject(new Error(rdata.message))
        }
      })
    })
  },
  SIGNOUT ({ dispatch, commit, state }) {
    return new Promise((resolve, reject) => {
      let data = {}
      signout(data).then(rdata => {
        commit('SET_USERINFO', {})
        removeUserInfo()
        if (rdata.code === 0 || rdata.code === 8888) {
          // userinfo
          resolve(rdata.data)
        } else {
          reject(rdata.message)
        }
      }).catch(err => {
        reject(err)
       })
    })
  },
  RESET ({ commit, state }, data) {
    return new Promise((resolve, reject) => {
      reset(data).then(rdata => {
        console.log('reset', rdata)
        if (rdata.status === 200) {
          resolve(rdata)
        } else {
          reject(new Error(rdata.message))
        }
      })
    })
  },
}


const mutations = {
  SET_USERINFO (state, value) {
    state.userinfo = value
  },
  M_SET_IDENTITY_ACCESS (state, value) {
    state.identityAccess = value
  }
}

const saveUserInfo = function (data) {
  saveItem('userinfo', JSON.stringify(data))
}
const removeUserInfo = function () {
  removeItem('userinfo')
  // removeAll()
}

const loadUserInfo = function () {
  return getItemObject('userinfo')
}


export default {
  state,
  getters,
  actions,
  mutations
}
